import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import i18n from '../i18n'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: `/${i18n.locale}/sos-download`
    },
    { 
      path:  '/:lang',
      redirect: to => {
        const { params } = to
        if (['en', 'de', 'es', 'fr', 'it', 'nl', 'pt', 'sv', 'cn', 'tw', 'ja'].indexOf(params.lang) > -1) {
          return '/:lang/sos-download'
        } else {
          return `/${i18n.locale}/sos-download`
        }
      }
    },
    {
      path: '*',
      redirect: `/${i18n.locale}/sos-download`
    },
    {
      path: `/${i18n.locale}`,
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/:lang(|en|de|es|it|pt|cn|fr|nl|sv|tw|ja)/sos-download',
          name: 'SOS Download',
          component: Home
        }
      ]
    }
  ]
})
